/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Sie haben die Höchstzahl an bevorzugten Routen erreicht.`
};

const en_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `You have reached the maximum number of favourite routes you can save.`
};

const es_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Has alcanzado el límite de itinerarios guardados en favoritos.`
};

const fr_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Vous avez atteint la limite de sauvegarde des itinéraires en favoris.`
};

const it_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `Hai raggiunto il limite degli itinerari da salvare nei preferiti.`
};

const nl_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `U hebt de limiet bereikt voor het opslaan van routes als favorieten.`
};

const pt_bookmark__favorite_limit_reached = /** @type {(inputs: {}) => string} */ () => {
	return `A sua capacidade máxima para guardar itinerários favoritos foi atingida.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__favorite_limit_reached(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__favorite_limit_reached", locale)
	if (locale === "de") return de_bookmark__favorite_limit_reached(inputs)
	if (locale === "en") return en_bookmark__favorite_limit_reached(inputs)
	if (locale === "es") return es_bookmark__favorite_limit_reached(inputs)
	if (locale === "fr") return fr_bookmark__favorite_limit_reached(inputs)
	if (locale === "it") return it_bookmark__favorite_limit_reached(inputs)
	if (locale === "nl") return nl_bookmark__favorite_limit_reached(inputs)
	return pt_bookmark__favorite_limit_reached(inputs)
};